var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71652 30H0.495536V9.97098H6.71652V30ZM3.60268 7.23884C1.61384 7.23884 0 5.59152 0 3.60268C0 2.64719 0.379567 1.73083 1.0552 1.0552C1.73083 0.379567 2.64719 0 3.60268 0C4.55817 0 5.47452 0.379567 6.15016 1.0552C6.82579 1.73083 7.20536 2.64719 7.20536 3.60268C7.20536 5.59152 5.59152 7.23884 3.60268 7.23884ZM29.9933 30H23.7857V20.25C23.7857 17.9263 23.7388 14.9464 20.5513 14.9464C17.317 14.9464 16.8214 17.471 16.8214 20.0826V30H10.6071V9.97098H16.5737V12.7031H16.6607C17.4911 11.1295 19.5201 9.46875 22.5469 9.46875C28.8415 9.46875 30 13.6138 30 18.9978V30H29.9933Z",
    fill: "#006CEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.35d7cd6ef15e473dbcf41c09c64e016e.svg";
export { ForwardRef as ReactComponent };